import React, { SetStateAction } from 'react'
import classes from './ItemAttributeForm.module.sass'
import { CategoryAttribute, ItemAttribute } from '../../types/interfaces'

import { useForm } from './hooks/useForm'
import { FormField } from './components/formField/FormField'

type Props<T> = {
  topData: T & { attributes: ItemAttribute[] }
  setTopData: React.Dispatch<React.SetStateAction<T & { attributes: ItemAttribute[] }>>
  categoryAttributes?: CategoryAttribute[]
  itemAttributes?: ItemAttribute[]
  setDisabled: React.Dispatch<SetStateAction<boolean>>
}

export const ItemAttributeForm = <T,>({
  categoryAttributes,
  itemAttributes,
  setDisabled,
  setTopData,
  topData,
}: Props<T>) => {
  const { data, handleAttributeChange, sort } = useForm(
    setTopData,
    topData,
    setDisabled,
    categoryAttributes,
    itemAttributes,
  )

  return (
    <div className={classes.container}>
      {data.sort(sort).map((el) => (
        <FormField el={el} onChange={handleAttributeChange} key={el.id} />
      ))}
    </div>
  )
}
